import { render } from "./CustomerContacts.vue?vue&type=template&id=0020b910&ts=true"
import script from "./CustomerContacts.vue?vue&type=script&lang=ts"
export * from "./CustomerContacts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__